<template>
    <div class="battery-progress" style="position: relative; width: 100%;">
        <div class="d-flex align-center mb-1">
            <v-icon color="primary" small class="mr-1">mdi-battery-10</v-icon>
            <span class="font-weight-bold">Bateria</span>
        </div>
        <div style="position: relative; width: 100%; height: 18px;">
            <div style="position: absolute; left: 0; top: 0; height: 18px; width: 100%; background: #e0e0e0; border-radius: 9px;"></div>
            <div :style="progressStyle" class="success white--text font-weight-bold">
                <span class="white--text font-weight-bold"
                    style="position: absolute; left: 50%; top: 0; transform: translateX(-50%); line-height: 18px; font-size: 13px; width: max-content;">
                    Carregou {{ end - start }}%
                </span>
            </div>
        </div>
        <div class="d-flex align-center mt-1" style="font-size: 13px;">
            <span><strong>Conectado:</strong> {{ start }}%</span>
            <v-spacer></v-spacer>
            <span><strong>Finalizando:</strong> {{ end }}%</span>
        </div>
        <div v-if="minutesTo80Percent > 0" class="d-flex align-center mt-1" style="font-size: 13px;">
            <span><strong>Minutos até 80%:</strong> {{ minutesTo80Percent }} min</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BatteryProgress',
    props: {
        start: {
            type: Number,
            required: true
        },
        end: {
            type: Number,
            required: true
        },
        minutesTo80Percent: {
            type: Number,
        },
    },
    computed: {
        progressStyle() {
            const left = this.start;
            const width = Math.max(this.end - this.start, 2); // mínimo 2% para visualização
            return {
                position: 'absolute',
                left: left + '%',
                top: '0',
                height: '18px',
                width: width + '%',
                borderRadius: '9px',
                transition: 'all 0.3s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'visible',
            };
        }
    }
};
</script>
